import ReactMarkdown from 'react-markdown'
// @ts-ignore
import terms from './terms.md'
import GenericLayout from 'components/GenericLayout'

function Terms() {
  return (
    <GenericLayout>
      <div className="prose pb-20 max-w-full">
        <ReactMarkdown>{terms}</ReactMarkdown>
      </div>
    </GenericLayout>
  )
}

export default Terms
